<template>
  <div id="invoice-create-by-home">
    <div
      class="card"
      :style="{ 'min-height': $store.state.screenHeight - 140 + 'px' }"
    >
      <div class="card-body">
        <h5 class="card-title">
          <i class="fas fa-file-invoice-dollar"></i>
          {{ $route.meta.title }}
        </h5>
        <hr />
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-8">
              <div class="form-group">
                <label>โซน:</label>
                <select class="form-control" v-model="zone_id">
                  <option value="">-- ทั้งหมด --</option>
                  <option v-for="(z, i) in zone_list" :key="'zone' + i" :value="z.zone_id">
                    ({{ z.zone_code }}) {{ z.zone_name }}
                  </option>
                </select>
              </div>

              <div class="form-group">
                <label>ค้นหาบ้านเลขที่:</label>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="กรอกบ้านเลขที่, ชื่อเจ้าบ้าน..."
                    v-model="search"
                    @keyup.enter="searchHome"
                  />
                  <div class="input-group-append">
                    <button
                      class="btn btn-outline-primary"
                      type="button"
                      @click="searchHome"
                    >
                      <i class="fas fa-search"></i> ค้นหา
                    </button>
                  </div>
                </div>
              </div>

              <!-- Result List -->
              <div v-if="date_bill" class="mb-3">
                 <label>ประจำเดือน:</label>
                 <input type="month" class="form-control" v-model="date_bill">
              </div>

              <div v-if="home_list.length > 0" class="list-group">
                <a
                  href="#"
                  class="list-group-item list-group-item-action"
                  v-for="(home, index) in home_list"
                  :key="index"
                  @click.prevent="selectHome(home)"
                  :class="{ 'active': selected_home && selected_home.home_id === home.home_id }"
                >
                  <div class="d-flex w-100 justify-content-between">
                    <h5 class="mb-1">บ้านเลขที่ {{ home.home_number }} (โซน {{ home.zone_code }})</h5>
                  </div>
                  <p class="mb-1">ชื่อเจ้าบ้าน: {{ home.home_fullname }}</p>
                  <small>เบอร์โทร: {{ home.home_phone }}</small>
                </a>
              </div>
              <div v-else-if="searched" class="text-center mt-3 text-muted">
                ไม่พบข้อมูลบ้านที่ค้นหา
              </div>

              <!-- Action Section -->
              <div v-if="selected_home" class="card mt-3 border-primary">
                <div class="card-header bg-primary text-white">
                  ยืนยันการสร้างใบแจ้งหนี้
                </div>
                <div class="card-body">
                  <p><strong>บ้านเลขที่:</strong> {{ selected_home.home_number }}</p>
                  <p><strong>เจ้าบ้าน:</strong> {{ selected_home.home_fullname }}</p>
                  <p><strong>เดือนที่จะออกใบแจ้งหนี้:</strong> {{ formatThaiMonth(date_bill) }}</p>

                  <div v-if="preview_loading" class="text-center my-3">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    กำลังโหลดรายการค่าใช้จ่าย...
                  </div>

                  <div v-else-if="preview" class="card mt-3">
                    <div class="card-header">
                      รายการค่าใช้จ่าย (Preview)
                    </div>
                    <div class="card-body p-0">
                      <table class="table mb-0">
                        <tbody>
                          <tr>
                            <td>ค่าส่วนกลาง</td>
                            <td class="text-right">{{ numberFormat(preview.summary.sum_central) }}</td>
                          </tr>
                          <tr>
                            <td>ค่าน้ำ</td>
                            <td class="text-right">{{ numberFormat(preview.summary.sum_water) }}</td>
                          </tr>
                          <tr>
                            <td>ค่าอื่นๆ</td>
                            <td class="text-right">{{ numberFormat(preview.summary.sum_other) }}</td>
                          </tr>
                          <tr>
                            <td>ค่าไฟ</td>
                            <td class="text-right">{{ numberFormat(preview.summary.sum_electric) }}</td>
                          </tr>
                          <tr>
                            <td>ยอดค้างชำระเดิม</td>
                            <td class="text-right">{{ numberFormat(preview.summary.sum_overdue) }}</td>
                          </tr>
                          <tr class="table-primary">
                            <td><strong>รวมที่ต้องชำระ</strong></td>
                            <td class="text-right"><strong>{{ numberFormat(preview.summary.sum_total_due) }}</strong></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="card-body" v-if="preview.current_month && preview.current_month.water_meter">
                      <div><strong>มิเตอร์น้ำเดือนนี้:</strong></div>
                      <div class="row">
                        <div class="col-sm-6">เลขมิเตอร์ปัจจุบัน: {{ preview.current_month.water_meter.water_income_unit }}</div>
                        <div class="col-sm-6">เลขมิเตอร์ก่อนหน้า: {{ preview.current_month.water_meter.water_total_last_unit }}</div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6">หน่วยที่ใช้: {{ preview.current_month.water_meter.diff_unit }}</div>
                        <div class="col-sm-6">ค่าน้ำ: {{ numberFormat(preview.current_month.water_meter.water_income_price) }}</div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="alert alert-warning" role="alert">
                    <i class="fas fa-exclamation-triangle"></i> ระบบจะทำการตรวจสอบว่ามีใบแจ้งหนี้ของเดือนนี้อยู่แล้วหรือไม่
                  </div>

                  <button 
                    class="btn btn-success btn-lg btn-block" 
                    @click="createInvoice" 
                    :disabled="loading || preview_loading"
                  >
                    <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span v-else><i class="fas fa-check-circle"></i> สร้างใบแจ้งหนี้</span>
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Con from '../../static/config.json'

export default {
  name: 'InvoiceCreateByHome',
  data () {
    return {
      search: '',
      zone_id: '',
      zone_list: [],
      searched: false,
      home_list: [],
      selected_home: null,
      date_bill: moment().format('YYYY-MM'),
      loading: false,
      preview: null,
      preview_loading: false
    }
  },
  mounted () {
    let header = {
      headers: {
        'access-token': this.$store.state.token
      }
    }
    this.axios.get(Con.URL + 'homezone/all', header).then(response => {
      if (response.data && response.data.response) {
        this.zone_list = response.data.data || []
      }
    }).catch(() => {})
  },
  watch: {
    date_bill () {
      if (this.selected_home) {
        this.fetchPreview()
      }
    }
  },
  methods: {
    numberFormat (value) {
      let n = Number(value)
      if (Number.isNaN(n)) return value
      return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    fetchPreview () {
      if (!this.selected_home || !this.date_bill) {
        this.preview = null
        return
      }

      this.preview_loading = true
      let header = {
        headers: {
          'access-token': this.$store.state.token
        }
      }
      let payload = {
        home_id: this.selected_home.home_id,
        date_bill: this.date_bill + '-16'
      }

      this.axios.post(Con.URL + 'invoice/previewbyhome', payload, header).then(response => {
        this.preview_loading = false
        if (response.data && response.data.response) {
          this.preview = response.data.data
        } else {
          this.preview = null
        }
      }).catch(() => {
        this.preview_loading = false
        this.preview = null
      })
    },
    searchHome () {
      if (!this.search) return
      this.searched = true
      this.selected_home = null
      this.loading = true
      this.preview = null

      let header = {
        headers: {
          'access-token': this.$store.state.token
        }
      }

      let filter = {
        search: this.search,
        zone: this.zone_id,
        active_page: 1,
        per_page: 50
      }

      this.axios.post(Con.URL + 'home/search', filter, header).then(response => {
        this.loading = false
        if (response.data.response) {
          this.home_list = response.data.data.pagination
        } else {
          this.home_list = []
        }
      }).catch(err => {
        this.loading = false
        console.error(err)
        alert('เกิดข้อผิดพลาดในการค้นหา')
      })
    },
    selectHome (home) {
      this.selected_home = home
      this.fetchPreview()
    },
    createInvoice () {
      if (!this.selected_home || !this.date_bill) return

      if (!confirm('ยืนยันการสร้างใบแจ้งหนี้สำหรับ ' + this.selected_home.home_number + ' ประจำเดือน ' + this.date_bill + '?')) return

      this.loading = true

      let header = {
        headers: {
          'access-token': this.$store.state.token
        }
      }

      let payload = {
        home_id: this.selected_home.home_id,
        date_bill: this.date_bill + '-16'
      }

      this.axios.post(Con.URL + 'invoice/generatebyhome', payload, header).then(response => {
        this.loading = false
        if (response.data.response) {
          alert('สร้างใบแจ้งหนี้เรียบร้อยแล้ว')
          this.selected_home = null
          this.search = ''
          this.home_list = []
          if (response.data.invoice_id) {
            this.$router.push({ name: 'InvoiceDetail', params: { key: response.data.invoice_id } })
          }
        } else {
          alert('ไม่สามารถสร้างใบแจ้งหนี้ได้: ' + (response.data.message || 'Unknown error'))
        }
      }).catch(err => {
        this.loading = false
        if (err.response && err.response.data && err.response.data.message) {
          alert('ข้อผิดพลาด: ' + err.response.data.message)
        } else {
          alert('เกิดข้อผิดพลาดในการเชื่อมต่อระบบ')
        }
      })
    },
    formatThaiMonth (dateStr) {
      if (!dateStr) return ''
      let date = moment(dateStr)
      let months = [
        'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
        'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
      ]
      return months[date.month()] + ' ' + (date.year() + 543)
    }
  }
}
</script>

<style scoped>
.list-group-item {
    cursor: pointer;
}
.list-group-item:hover {
    background-color: #f8f9fa;
}
.active {
    background-color: #007bff !important;
    color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/views/invoice_create_by_home.vue